<div class="register-container">
  <div class="register-card">
    <!-- Header -->
    <div class="register-header">
      <div class="d-flex justify-content-between align-items-start w-100">
        <div>
          <div class="brand-section">
            <img src="/vat-logo.png" alt="VAT Logo" class="vat-logo">
            <h2 class="brand-title">VAT E-Service</h2>
          </div>
          <h1 class="register-title">แก้ไขข้อมูลผู้ใช้งาน</h1>
          <p class="register-subtitle">แก้ไขข้อมูลส่วนตัวและข้อมูลวิชาชีพของคุณ</p>
        </div>
        <div class="contact-box mt-4 mt-md-0">
          <div class="contact-label">
            <i class="bi bi-question-circle-fill me-1"></i>
            ต้องการแก้ไขข้อมูล?
          </div>
          <button type="button" class="btn btn-light fw-bold text-primary shadow-sm" (click)="openContactModal()">
            <i class="bi bi-envelope-fill me-2"></i> ติดต่อเจ้าหน้าที่
          </button>
        </div>
      </div>
    </div>

    <!-- Progress Bar -->
    <div class="progress-section">
      <div class="progress">
        <div class="progress-bar" role="progressbar" [style.width.%]="(currentStep / totalSteps) * 100"></div>
      </div>
      <div class="progress-steps">
        <div *ngFor="let step of [1, 2]" class="step-item">
          <div class="step-circle" [class.completed]="step < currentStep" [class.current]="step === currentStep"
            [class.clickable]="step <= currentStep" (click)="goToStep(step)">
            <i *ngIf="step < currentStep" class="bi bi-check-lg"></i>
            <span *ngIf="step >= currentStep">{{ step }}</span>
          </div>
          <div class="step-label">
            <span *ngIf="step === 1">ข้อมูลส่วนตัว</span>
            <span *ngIf="step === 2">ข้อมูลวิชาชีพ</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading Indicator -->
    <div *ngIf="isLoadingUserData" class="loading-overlay">
      <div class="loading-content">
        <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
          <span class="visually-hidden">กำลังโหลดข้อมูล...</span>
        </div>
        <p class="mt-3">กำลังโหลดข้อมูลผู้ใช้...</p>
      </div>
    </div>

    <!-- Rejection Reason Alert -->
    <div *ngIf="userStatusId === 3 && userStatusNote" class="alert alert-warning rejection-alert" role="alert">
      <div class="d-flex align-items-start">
        <div class="alert-icon">
          <i class="bi bi-exclamation-triangle-fill"></i>
        </div>
        <div class="alert-content">
          <h5 class="alert-heading mb-2">
            <i class="bi bi-info-circle me-2"></i>ข้อมูลของคุณไม่ผ่านการอนุมัติ
          </h5>
          <p class="mb-2"><strong>เหตุผล:</strong></p>
          <p class="rejection-reason">{{ userStatusNote }}</p>
          <hr class="my-2">
          <p class="mb-0 text-muted small">
            <i class="bi bi-lightbulb me-1"></i>
            กรุณาแก้ไขข้อมูลตามเหตุผลที่ระบุข้างต้น แล้วกดปุ่ม "แก้ไขข้อมูล" เพื่อส่งข้อมูลให้ผู้ดูแลระบบตรวจสอบอีกครั้ง
          </p>
        </div>
      </div>
    </div>

    <!-- Form -->
    <form [formGroup]="createUserForm" (ngSubmit)="onSubmit()" class="register-form" *ngIf="!isLoadingUserData">

      <!-- Step 1: Personal Information -->
      <div class="step-content" *ngIf="currentStep === 1">
        <div class="form-section">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h3 class="section-title mb-0">
              <i class="bi bi-person-circle"></i>
              ข้อมูลส่วนตัว
            </h3>

          </div>

          <div class="row mb-4">
            <div class="col-12 text-center">
              <img *ngIf="createUserForm.get('profilePicture')?.value"
                [src]="createUserForm.get('profilePicture')?.value" class="rounded-circle profile-preview shadow-sm"
                style="width: 150px; height: 150px; object-fit: cover; border: 3px solid #dee2e6; background-color: #f8f9fa; cursor: pointer;"
                alt="Profile Picture" (click)="viewImage(createUserForm.get('profilePicture')?.value)">
              <div *ngIf="!createUserForm.get('profilePicture')?.value"
                class="rounded-circle profile-preview shadow-sm mx-auto d-flex align-items-center justify-content-center bg-light text-secondary"
                style="width: 150px; height: 150px; border: 3px dashed #dee2e6;">
                <i class="bi bi-person-fill" style="font-size: 4rem; opacity: 0.5;"></i>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2 mb-3">
              <label class="form-label required">คำนำหน้า</label>
              <select class="form-select" formControlName="prefix" [class.is-invalid]="hasError('prefix')">
                <option value="">เลือก</option>
                <option value="นาย">นาย</option>
                <option value="นาง">นาง</option>
                <option value="นางสาว">นางสาว</option>
              </select>
              <div class="invalid-feedback" *ngIf="hasError('prefix')">
                {{ getErrorMessage('prefix') }}
              </div>
            </div>

            <div class="col-md-5 mb-3">
              <label class="form-label required">ชื่อ</label>
              <input type="text" class="form-control" formControlName="firstName"
                [class.is-invalid]="hasError('firstName')" placeholder="">
              <div class="invalid-feedback" *ngIf="hasError('firstName')">
                {{ getErrorMessage('firstName') }}
              </div>
            </div>

            <div class="col-md-5 mb-3">
              <label class="form-label required">นามสกุล</label>
              <input type="text" class="form-control" formControlName="lastName"
                [class.is-invalid]="hasError('lastName')" placeholder="">
              <div class="invalid-feedback" *ngIf="hasError('lastName')">
                {{ getErrorMessage('lastName') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label required">อีเมล</label>
              <input type="email" class="form-control" formControlName="email" [class.is-invalid]="hasError('email')"
                placeholder="">
              <div class="invalid-feedback" *ngIf="hasError('email')">
                {{ getErrorMessage('email') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label required">เบอร์โทรศัพท์</label>
              <input type="tel" class="form-control" formControlName="phone" [class.is-invalid]="hasError('phone')"
                placeholder="" maxlength="10">
              <div class="invalid-feedback" *ngIf="hasError('phone')">
                {{ getErrorMessage('phone') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label required">เลขบัตรประชาชน</label>
              <input type="text" class="form-control" formControlName="cid" [class.is-invalid]="hasError('cid')"
                placeholder="" maxlength="13" readonly>
              <small class="form-text text-muted" *ngIf="userCid">
                <i class="bi bi-info-circle"></i> ข้อมูลจากบัญชีผู้ใช้ของคุณ (ไม่สามารถแก้ไขได้)
              </small>
              <div class="invalid-feedback" *ngIf="hasError('cid')">
                {{ getErrorMessage('cid') }}
              </div>
            </div>

            <div class="col-md-3 mb-3">
              <label class="form-label required">เพศ</label>
              <select class="form-select" formControlName="gender" [class.is-invalid]="hasError('gender')">
                <option value="">เลือกเพศ</option>
                <option value="Male">ชาย</option>
                <option value="Female">หญิง</option>
              </select>
              <div class="invalid-feedback" *ngIf="hasError('gender')">
                {{ getErrorMessage('gender') }}
              </div>
            </div>

            <div class="col-md-3 mb-3">
              <label class="form-label required">วันเกิด (พ.ศ.)</label>
              <input type="text" class="form-control" formControlName="birthDate"
                [class.is-invalid]="hasError('birthDate')"
                placeholder="dd/mm/yyyy"
                maxlength="10"
                (input)="onBirthDateInput($event)"
                (blur)="validateBirthDate()">
              <div class="invalid-feedback" *ngIf="hasError('birthDate')">
                {{ getErrorMessage('birthDate') }}
              </div>
              <small class="text-muted d-block mt-1">
                <i class="bi bi-info-circle"></i> รูปแบบ: วว/ดด/ปปปป (พ.ศ.) เช่น 15/05/2543
              </small>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">เลือกที่ทำงานปัจจุบัน</label>
              <select class="form-select" formControlName="companyId" [disabled]="isLoadingCompanies"
                (change)="onCompanySelect($event)">
                <option value="">-- เลือกองค์กร --</option>
                <option *ngFor="let company of companyList" [value]="company.id">
                  {{ company.organizationName }}
                </option>
              </select>
              <small class="form-text text-muted" *ngIf="isLoadingCompanies">
                <i class="bi bi-hourglass-split"></i> กำลังโหลดรายการองค์กร...
              </small>
            </div>

            <!-- Company Details Display - Improved Design -->
            <div class="col-md-12 mb-3" *ngIf="selectedCompany">
              <div class="card shadow-sm border-0">
                <div class="card-header bg-primary text-white">
                  <h6 class="mb-0">
                    <i class="bi bi-building-fill me-2"></i>
                    รายละเอียดองค์กร
                  </h6>
                </div>
                <div class="card-body">
                  <div class="row g-3">
                    <!-- Organization Name - Full Width -->
                    <div class="col-12">
                      <div class="d-flex align-items-center mb-2">
                        <i class="bi bi-building text-primary me-2"></i>
                        <strong>ชื่อองค์กร:</strong>
                      </div>
                      <div class="ms-4">{{ selectedCompany.organizationName }}</div>
                    </div>

                    <div class="col-md-6 mb-2">
                      <div class="d-flex align-items-start">
                        <i class="bi bi-tag-fill text-primary me-2 mt-1"></i>
                        <div>
                          <small class="text-muted d-block">ประเภท</small>
                          <span>{{ selectedCompany.organizationType }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 mb-2">
                      <div class="d-flex align-items-start">
                        <i class="bi bi-credit-card-fill text-primary me-2 mt-1"></i>
                        <div>
                          <small class="text-muted d-block">เลขประจำตัวผู้เสียภาษี</small>
                          <span>{{ selectedCompany.taxId }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 mb-2">
                      <div class="d-flex align-items-start">
                        <i class="bi bi-telephone-fill text-primary me-2 mt-1"></i>
                        <div>
                          <small class="text-muted d-block">โทรศัพท์</small>
                          <span>{{ selectedCompany.officePhone }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 mb-2">
                      <div class="d-flex align-items-start">
                        <i class="bi bi-envelope-fill text-primary me-2 mt-1"></i>
                        <div>
                          <small class="text-muted d-block">อีเมล</small>
                          <span>{{ selectedCompany.email }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 mb-2">
                      <div class="d-flex align-items-start">
                        <i class="bi bi-globe text-primary me-2 mt-1"></i>
                        <div>
                          <small class="text-muted d-block">เว็บไซต์</small>
                          <span>{{ selectedCompany.website || '-' }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 mb-2">
                      <div class="d-flex align-items-start">
                        <i class="bi bi-chat-dots-fill text-success me-2 mt-1"></i>
                        <div>
                          <small class="text-muted d-block">Line ID</small>
                          <span>{{ selectedCompany.lineId || '-' }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 mb-0">
                      <div class="d-flex align-items-start">
                        <i class="bi bi-geo-alt-fill text-danger me-2 mt-1"></i>
                        <div>
                          <small class="text-muted d-block">ที่อยู่</small>
                          <span>{{ selectedCompany.headOfficeAddress }}, {{ selectedCompany.taxSubdistrict }}, {{
                            selectedCompany.taxDistrict }}, {{ selectedCompany.taxProvince }} {{
                            selectedCompany.postalCode }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Address Section -->
        <div class="form-section">
          <h3 class="section-title">
            <i class="bi bi-house-door"></i>
            ที่อยู่
          </h3>

          <!-- Registered Address -->
          <div class="address-card registered">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h4 class="address-title mb-0">ที่อยู่ตามทะเบียนบ้าน</h4>

            </div>
            <div class="row">
              <div class="col-md-12 mb-3">
                <label class="form-label required">ที่อยู่</label>
                <input type="text" class="form-control" formControlName="registeredAddress"
                  [class.is-invalid]="hasError('registeredAddress')" placeholder="บ้านเลขที่ ซอย ถนน">
                <div class="invalid-feedback" *ngIf="hasError('registeredAddress')">
                  {{ getErrorMessage('registeredAddress') }}
                </div>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label required">ตำบล/แขวง</label>
                <input type="text" class="form-control" formControlName="registeredSubdistrict"
                  [class.is-invalid]="hasError('registeredSubdistrict')" placeholder="ตำบล/แขวง">
                <div class="invalid-feedback" *ngIf="hasError('registeredSubdistrict')">
                  {{ getErrorMessage('registeredSubdistrict') }}
                </div>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label required">อำเภอ/เขต</label>
                <input type="text" class="form-control" formControlName="registeredDistrict"
                  [class.is-invalid]="hasError('registeredDistrict')" placeholder="อำเภอ/เขต">
                <div class="invalid-feedback" *ngIf="hasError('registeredDistrict')">
                  {{ getErrorMessage('registeredDistrict') }}
                </div>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label required">จังหวัด</label>
                <input type="text" class="form-control" formControlName="registeredProvince"
                  [class.is-invalid]="hasError('registeredProvince')" placeholder="จังหวัด">
                <div class="invalid-feedback" *ngIf="hasError('registeredProvince')">
                  {{ getErrorMessage('registeredProvince') }}
                </div>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label required">รหัสไปรษณีย์</label>
                <input type="text" class="form-control" formControlName="registeredPostalCode"
                  [class.is-invalid]="hasError('registeredPostalCode')" placeholder="XXXXX" maxlength="5">
                <div class="invalid-feedback" *ngIf="hasError('registeredPostalCode')">
                  {{ getErrorMessage('registeredPostalCode') }}
                </div>
              </div>
            </div>
          </div>

          <!-- Current Address -->
          <div class="address-card current">
            <div class="address-header">
              <div class="d-flex justify-content-between align-items-center w-100">
                <div class="d-flex align-items-center gap-3">
                  <h4 class="address-title mb-0">ที่อยู่ปัจจุบัน</h4>
                  <div class="form-check mb-0">
                    <input class="form-check-input" type="checkbox" id="sameAsRegistered"
                      formControlName="sameAsRegistered" (change)="onSameAsRegisteredChange($event)">
                    <label class="form-check-label" for="sameAsRegistered">
                      เหมือนที่อยู่ตามทะเบียนบ้าน
                    </label>
                  </div>
                </div>

              </div>
            </div>

            <div class="row">
              <div class="col-md-12 mb-3">
                <label class="form-label required">ที่อยู่</label>
                <input type="text" class="form-control" formControlName="currentAddress"
                  [class.is-invalid]="hasError('currentAddress')" placeholder="บ้านเลขที่ ซอย ถนน">
                <div class="invalid-feedback" *ngIf="hasError('currentAddress')">
                  {{ getErrorMessage('currentAddress') }}
                </div>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label required">ตำบล/แขวง</label>
                <input type="text" class="form-control" formControlName="currentSubdistrict"
                  [class.is-invalid]="hasError('currentSubdistrict')" placeholder="ตำบล/แขวง">
                <div class="invalid-feedback" *ngIf="hasError('currentSubdistrict')">
                  {{ getErrorMessage('currentSubdistrict') }}
                </div>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label required">อำเภอ/เขต</label>
                <input type="text" class="form-control" formControlName="currentDistrict"
                  [class.is-invalid]="hasError('currentDistrict')" placeholder="อำเภอ/เขต">
                <div class="invalid-feedback" *ngIf="hasError('currentDistrict')">
                  {{ getErrorMessage('currentDistrict') }}
                </div>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label required">จังหวัด</label>
                <input type="text" class="form-control" formControlName="currentProvince"
                  [class.is-invalid]="hasError('currentProvince')" placeholder="จังหวัด">
                <div class="invalid-feedback" *ngIf="hasError('currentProvince')">
                  {{ getErrorMessage('currentProvince') }}
                </div>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label required">รหัสไปรษณีย์</label>
                <input type="text" class="form-control" formControlName="currentPostalCode"
                  [class.is-invalid]="hasError('currentPostalCode')" placeholder="XXXXX" maxlength="5">
                <div class="invalid-feedback" *ngIf="hasError('currentPostalCode')">
                  {{ getErrorMessage('currentPostalCode') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 2: Professional Information -->
      <div class="step-content" *ngIf="currentStep === 2">
        <div class="form-section">
          <h3 class="section-title">
            <i class="bi bi-briefcase"></i>
            ข้อมูลวิชาชีพ
          </h3>

          <!-- VAT Member Zone (Read-Only) -->
          <div class="professional-card vat-member">
            <h4 class="professional-title">
              <i class="bi bi-award"></i>
              สมาชิก VAT
            </h4>
            <div class="alert alert-info mb-3">
              <i class="bi bi-info-circle me-2"></i>
              <small>ข้อมูลสมาชิก VAT ไม่สามารถแก้ไขได้ กรุณาติดต่อเจ้าหน้าที่หากต้องการเปลี่ยนแปลงข้อมูล</small>
            </div>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">ประเภทสมาชิก VAT</label>
                <select class="form-select" formControlName="vatMemberType">
                  <option value="ยังไม่มีบัตรสมาชิก">ยังไม่มีบัตรสมาชิก</option>
                  <option value="วิสามัญ">วิสามัญ</option>
                  <option value="สามัญ">สามัญ</option>
                  <option value="ตลอดชีพ">ตลอดชีพ</option>
                </select>
              </div>

              <div class="col-md-6 mb-3" *ngIf="createUserForm.get('vatMemberType')?.value !== 'ยังไม่มีบัตรสมาชิก'">
                <label class="form-label">วันหมดอายุสมาชิก VAT</label>
                <input type="date" class="form-control" formControlName="vatMemberExpiry">
                <div class="form-check mt-2">
                  <input class="form-check-input" type="checkbox" formControlName="isLifetimeMember"
                    id="isLifetimeMember">
                  <label class="form-check-label" for="isLifetimeMember">
                    ตลอดชีพ
                  </label>
                </div>
              </div>

              <div class="col-md-6 mb-3" *ngIf="createUserForm.get('vatMemberType')?.value !== 'ยังไม่มีบัตรสมาชิก'">
                <label class="form-label">หมายเลขสมาชิก VAT (VAT ID)</label>
                <input type="text" class="form-control" formControlName="vatId">
              </div>
            </div>
          </div>

          <!-- Valuer Zone (Read-Only) -->
          <div class="professional-card valuer">
            <h4 class="professional-title">
              <i class="bi bi-star"></i>
              ผู้ประเมินหลัก
            </h4>
            <div class="alert alert-info mb-3">
              <i class="bi bi-info-circle me-2"></i>
              <small>ข้อมูลผู้ประเมินหลักไม่สามารถแก้ไขได้ กรุณาติดต่อเจ้าหน้าที่หากต้องการเปลี่ยนแปลงข้อมูล</small>
            </div>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">ผู้ประเมินหลักประเภท (Valuer Rank)</label>
                <select class="form-select" formControlName="valuerRank">
                  <option value="ไม่มี">ไม่มี</option>
                  <option value="วิสามัญ">วิสามัญ</option>
                  <option value="สามัญ">สามัญ</option>
                  <option value="วุฒิ">วุฒิ</option>
                </select>
              </div>

              <div class="col-md-6 mb-3" *ngIf="createUserForm.get('valuerRank')?.value !== 'ไม่มี'">
                <label class="form-label">วันหมดอายุชั้นผู้ประเมิน</label>
                <input type="date" class="form-control" formControlName="valuerRankExpiry">
              </div>

              <div class="col-md-6 mb-3" *ngIf="createUserForm.get('valuerRank')?.value !== 'ไม่มี'">
                <label class="form-label">หมายเลขผู้ประเมินหลัก</label>
                <input type="text" class="form-control" formControlName="valuerId">
              </div>
            </div>
          </div>

          <!-- Valuation Experience -->
          <div class="dynamic-section">
            <div class="section-header">
              <h4>ประสบการณ์การประเมินมูลค่า</h4>

            </div>

            <div *ngFor="let exp of valuationExperience.controls; let i = index" class="dynamic-item">
              <div class="row">
                <div class="col-md-4 mb-3">
                  <label class="form-label">องค์กร</label>
                  <input type="text" class="form-control" [formControl]="$any(exp).get('organization')"
                    placeholder="ชื่อองค์กร">
                </div>

                <div class="col-md-4 mb-3">
                  <label class="form-label">ตำแหน่ง</label>
                  <input type="text" class="form-control" [formControl]="$any(exp).get('position')"
                    placeholder="ตำแหน่งงาน">
                </div>

                <div class="col-md-3 mb-3">
                  <label class="form-label">จำนวนปี</label>
                  <input type="number" class="form-control" [formControl]="$any(exp).get('years')" placeholder="ปี"
                    min="0">
                </div>


              </div>
            </div>
          </div>

          <!-- Education Background -->
          <div class="dynamic-section">
            <div class="section-header">
              <h4>ประวัติการศึกษา</h4>

            </div>

            <div *ngFor="let edu of educationBackground.controls; let i = index" class="dynamic-item">
              <div class="row">
                <div class="col-md-5 mb-3">
                  <label class="form-label">สถาบันการศึกษา</label>
                  <input type="text" class="form-control" [formControl]="$any(edu).get('institution')"
                    placeholder="ชื่อสถาบัน">
                </div>

                <div class="col-md-4 mb-3">
                  <label class="form-label">วุฒิการศึกษา/สาขา</label>
                  <input type="text" class="form-control" [formControl]="$any(edu).get('degree')"
                    placeholder="ปริญญา/สาขา">
                </div>

                <div class="col-md-2 mb-3">
                  <label class="form-label">ปีที่จบ (พ.ศ.)</label>
                  <input type="number" class="form-control" [formControl]="$any(edu).get('year')" placeholder="2566"
                    min="2500" max="2600">
                </div>


              </div>
            </div>
          </div>

          <!-- VAT Courses -->
          <div class="dynamic-section">
            <div class="section-header">
              <h4>ผ่านการอบรม/สัมมนา ที่จัดโดย VAT และ กลต.ช่วง พ.ศ 2564-2568</h4>

            </div>

            <div *ngIf="isLoadingCourses" class="text-center py-3">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">กำลังโหลดคอร์ส...</span>
              </div>
              <p class="mt-2">กำลังโหลดรายการคอร์ส...</p>
            </div>

            <div *ngFor="let course of vatCourses.controls; let i = index" class="dynamic-item">
              <div class="row">
                <div class="col-md-5 mb-3">
                  <label class="form-label">เลือกคอร์สอบรม/สัมมนา</label>
                  <select class="form-select" [formControl]="$any(course).get('courseId')"
                    (change)="onCourseSelect(i, $event)" [disabled]="isLoadingCourses">
                    <option value="">-- เลือกคอร์ส --</option>
                    <option *ngFor="let c of courseList" [value]="c.id">
                      {{ c.title }}
                    </option>
                  </select>
                </div>

                <div class="col-md-3 mb-3">
                  <label class="form-label">จำนวน CPD (ชั่วโมง)</label>
                  <input type="number" class="form-control" [formControl]="$any(course).get('cpdHours')" placeholder="0"
                    readonly min="0">
                </div>

                <div class="col-md-3 mb-3">
                  <label class="form-label">วันที่จบหลักสูตร</label>
                  <input type="date" class="form-control" [formControl]="$any(course).get('completionDate')"
                    placeholder="เลือกวันที่" readonly>
                </div>

                <div class="col-md-12 mb-3">
                  <label class="form-label">อัพโหลดหลักฐาน (รูปภาพ หรือ PDF)</label>
                  <!-- File input removed for view-only mode -->
                  <div *ngIf="!$any(course).get('imageThumbnail')?.value" class="alert alert-secondary py-2">
                    <small><i class="bi bi-info-circle me-1"></i> ไม่มีไฟล์หลักฐาน</small>
                  </div>
                  <div *ngIf="$any(course).get('uploadStatus')?.value === 'uploading'" class="mt-2">
                    <span class="badge bg-info">
                      <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                      กำลังอัพโหลด...
                    </span>
                  </div>
                  <div *ngIf="$any(course).get('uploadStatus')?.value === 'success'" class="mt-2">
                    <span class="badge bg-success">
                      <i class="bi bi-check-circle-fill me-1"></i> อัพโหลดสำเร็จ
                    </span>
                  </div>
                  <div *ngIf="$any(course).get('uploadStatus')?.value === 'error'" class="mt-2">
                    <span class="badge bg-danger">
                      <i class="bi bi-x-circle-fill me-1"></i> อัพโหลดล้มเหลว
                    </span>
                  </div>
                  <div *ngIf="$any(course).get('imageThumbnail')?.value" class="mt-2">
                    <button type="button" class="btn btn-primary btn-sm" (click)="viewVatCourseImage(i)">
                      <i class="bi bi-file-earmark-text me-1"></i> ดูไฟล์หลักฐาน
                    </button>
                  </div>
                </div>


              </div>
            </div>
          </div>

          <!-- Special Courses by Other Organizations -->
          <div class="dynamic-section">
            <div class="section-header">
              <h4>หัวข้ออบรม/สัมมนา ที่จัดโดยหน่วยงานอื่น</h4>

            </div>

            <div *ngFor="let course of specialCourses.controls; let i = index" class="dynamic-item">
              <div class="row g-3">
                <div class="col-lg-4 col-md-6 mb-3">
                  <label class="form-label fw-semibold">
                    <i class="bi bi-book me-1 text-primary"></i>หัวข้อหลักสูตร
                  </label>
                  <input type="text" class="form-control form-control-lg"
                    [formControl]="$any(course).get('courseTopic')" placeholder="กรอกชื่อหลักสูตร">
                </div>

                <div class="col-lg-4 col-md-6 mb-3">
                  <label class="form-label fw-semibold">
                    <i class="bi bi-building me-1 text-success"></i>หน่วยงาน/สถาบัน
                  </label>
                  <input type="text" class="form-control form-control-lg"
                    [formControl]="$any(course).get('organization')" placeholder="กรอกชื่อหน่วยงาน">
                </div>

                <div class="col-lg-2 col-md-4 mb-3">
                  <label class="form-label fw-semibold">
                    <i class="bi bi-clock me-1 text-info"></i>CPD (ชั่วโมง)
                  </label>
                  <input type="number" class="form-control form-control-lg text-center"
                    [formControl]="$any(course).get('cpdHours')" placeholder="0" min="0" step="0.5">
                </div>


              </div>

              <!-- Second Row for Date and Status -->
              <div class="row g-3 mt-1">
                <div class="col-lg-6 col-md-8 mb-3">
                  <label class="form-label fw-semibold">
                    <i class="bi bi-calendar-event me-1 text-warning"></i>วันที่เข้ารับการอบรม
                  </label>
                  <input type="date" class="form-control form-control-lg"
                    [formControl]="$any(course).get('trainingDate')" title="เลือกวันที่เข้ารับการอบรม">
                </div>

              </div>

              <!-- Divider between items -->
              <hr class="my-4 border-2 border-light" *ngIf="i < specialCourses.length - 1">
            </div>
          </div>

        </div>
      </div>

      <!-- Navigation Buttons -->
      <div class="form-actions">
        <button type="button" class="btn btn-secondary" (click)="cancel()">
          <i class="bi bi-x-lg"></i> ยกเลิก
        </button>

        <div class="action-buttons">
          <button type="button" class="btn btn-outline-primary" *ngIf="currentStep > 1" (click)="prevStep()">
            <i class="bi bi-arrow-left"></i> ย้อนกลับ
          </button>

          <button type="button" class="btn btn-primary" *ngIf="currentStep < totalSteps" (click)="nextStep()">
            ถัดไป <i class="bi bi-arrow-right"></i>
          </button>

          <!-- <button type="button" class="btn btn-info" *ngIf="currentStep === totalSteps" (click)="debugShowPayload()" [disabled]="isLoadingUserData">
            <i class="bi bi-bug"></i> Debug JSON
          </button> -->


        </div>
      </div>
    </form>

    <!-- Footer -->
    <div class="register-footer">
      <p><a href="/user/dashboard" class="login-link">← กลับไปหน้าแดชบอร์ด</a></p>
      <p class="copyright">&copy; 2026 VAT Management System. All rights reserved.</p>
    </div>
  </div>
</div>

<!-- Debug JSON Modal -->
<div class="modal fade show" [class.d-block]="showDebugModal" [style.display]="showDebugModal ? 'block' : 'none'"
  tabindex="-1" role="dialog" *ngIf="showDebugModal">
  <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header bg-dark text-white">
        <h5 class="modal-title">
          <i class="bi bi-bug-fill me-2"></i>
          Debug: JSON Structure ที่จะส่งไปยัง Backend
        </h5>
        <button type="button" class="btn-close btn-close-white" (click)="closeDebugModal()"></button>
      </div>
      <div class="modal-body bg-dark text-light" style="max-height: 70vh; overflow-y: auto;">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div>
            <span class="badge bg-info me-2">
              <i class="bi bi-code-square"></i> JSON Format
            </span>
            <span class="badge bg-success">
              <i class="bi bi-check-circle"></i> Ready to Send
            </span>
          </div>
          <button type="button" class="btn btn-sm btn-outline-light" (click)="copyDebugJson()">
            <i class="bi bi-clipboard"></i> Copy to Clipboard
          </button>
        </div>
        <pre class="bg-black text-success p-3 rounded"
          style="font-family: 'Courier New', monospace; font-size: 13px; line-height: 1.5; white-space: pre-wrap; word-wrap: break-word;">{{ debugJsonData }}</pre>
      </div>
      <div class="modal-footer bg-dark border-secondary">
        <button type="button" class="btn btn-outline-light" (click)="copyDebugJson()">
          <i class="bi bi-clipboard"></i> Copy JSON
        </button>
        <button type="button" class="btn btn-primary" (click)="closeDebugModal()">
          <i class="bi bi-x-lg"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop -->
<div class="modal-backdrop fade show" *ngIf="showDebugModal" (click)="closeDebugModal()"></div>

<!-- Contact Admin Modal -->
<div class="modal fade show" [class.d-block]="showContactModal" [style.display]="showContactModal ? 'block' : 'none'"
  tabindex="-1" role="dialog" *ngIf="showContactModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
          <i class="bi bi-envelope-fill me-2"></i>
          ติดต่อเจ้าหน้าที่เพื่อแก้ไขข้อมูล
        </h5>
        <button type="button" class="btn-close btn-close-white" (click)="closeContactModal()"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label class="form-label fw-bold">รายละเอียดที่ต้องการแก้ไข:</label>
          <textarea class="form-control" rows="6" placeholder="ระบุรายละเอียดข้อมูลที่ต้องการแก้ไข..."
            [value]="contactMessage" (input)="contactMessage = $any($event).target.value"></textarea>
          <div class="mt-2 text-muted small">
            <i class="bi bi-info-circle-fill me-1"></i>
            ระบบจะทำการส่งรายการขอแก้ไขไปยังเจ้าหน้าที่ กรุณารอการตอบกลับจากเจ้าหน้าที่ทางอีเมล์ของคุณ
          </div>
        </div>

        <!-- ไฟล์แนบประกอบคำขอ เพื่อให้เจ้าหน้าที่ตรวจสอบแล้วแก้ไขให้ได้ทันที -->
        <div class="mb-1 contact-attachment">
          <label class="form-label fw-bold">ไฟล์ประกอบ (ถ้ามี):</label>

          <div *ngIf="!contactAttachment">
            <label class="btn btn-outline-primary btn-sm mb-0">
              <i class="bi bi-paperclip me-1"></i> เลือกไฟล์
              <input type="file" class="d-none" [accept]="contactAttachmentAccept"
                (change)="onContactAttachmentSelected($event)">
            </label>
          </div>

          <div *ngIf="contactAttachment" class="attachment-chip d-flex align-items-center gap-2">
            <i class="bi bi-file-earmark-check-fill text-primary"></i>
            <span class="attachment-name text-truncate">{{ contactAttachment.name }}</span>
            <span class="text-muted small flex-shrink-0">({{ formatFileSize(contactAttachment.size) }})</span>

            <span *ngIf="isUploadingAttachment" class="text-muted small flex-shrink-0">
              <span class="spinner-border spinner-border-sm me-1"></span>กำลังอัปโหลด...
            </span>
            <span *ngIf="!isUploadingAttachment && contactAttachmentUrl"
              class="text-success small flex-shrink-0">
              <i class="bi bi-check-circle-fill me-1"></i>พร้อมส่ง
            </span>

            <button type="button" class="btn btn-sm btn-link text-danger p-0 ms-auto flex-shrink-0"
              (click)="removeContactAttachment()" [disabled]="isUploadingAttachment">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div *ngIf="contactAttachmentError" class="mt-2 text-danger small">
            <i class="bi bi-exclamation-triangle-fill me-1"></i>{{ contactAttachmentError }}
          </div>

          <div class="mt-2 text-muted small">
            <i class="bi bi-info-circle-fill me-1"></i>
            รองรับไฟล์ JPEG, JPG, PNG และ PDF ขนาดไม่เกิน 25MB
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeContactModal()">ยกเลิก</button>
        <button type="button" class="btn btn-primary" (click)="sendContactEmail()"
          [disabled]="isSubmitting || isUploadingAttachment">
          <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-1"></span>
          <i *ngIf="!isSubmitting" class="bi bi-send-fill me-1"></i> ส่งข้อมูล
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop for Contact Modal -->
<div class="modal-backdrop fade show" *ngIf="showContactModal" style="z-index: 1040;" (click)="closeContactModal()">
</div>